import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { MFA_SETUP_ROUTE, isMfaEnrollmentRequired } from '../mfa.contract';

const DELETED_USER_ERROR_QUERY = 'AUTHENTICATION_ERROR-DELETED_USER';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}
  router = inject(Router);

  private isDeletedUserError(errorName: string | undefined): boolean {
    return errorName?.includes('DELETED_USER') ?? false;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map((res) => {
        return res;
      }),
      catchError((error: HttpErrorResponse) => {
        // console.error(error);
        if (this.isDeletedUserError(error.error?.name)) {
          void this.authService.SignOut(DELETED_USER_ERROR_QUERY);
          return throwError(() => error);
        }
        // Must sit ABOVE the 403 branch. The user is authenticated and their password is
        // fine - they simply owe a second factor - so signing them out (what 403 does)
        // would strand them at the login screen, away from the enrolment page. Route them
        // to it instead, and never bounce a request that is already on that page or the
        // policy endpoint, or the redirect loops.
        if (isMfaEnrollmentRequired(error)) {
          if (!this.router.url.startsWith(MFA_SETUP_ROUTE)) {
            void this.router.navigateByUrl(MFA_SETUP_ROUTE);
          }
          return throwError(() => error);
        }
        else if (error.status === 403) void this.authService.SignOut(error.error.name);
        if (error.status === 402) this.router.navigateByUrl('/payment-issue');

        return throwError(() => error);
      })
    );
  }
}
